import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NetworkStatusService } from '../../domain/network/network-status.service';
import {
  ENetworkStatusActions,
  CheckNetworkStatusSuccess,
  CheckNetworkStatusFailure
} from '../actions/network-status.actions';
import { of } from 'rxjs';

@Injectable()
export class NetworkStatusEffects {
  constructor(private networkstatusService: NetworkStatusService) {}

  private readonly actions$ = inject(Actions);

  checkNetworkStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ENetworkStatusActions.CheckNetworkStatus),
      switchMap(() =>
        this.networkstatusService.checkNetworkStatus().pipe(
          map(payload => new CheckNetworkStatusSuccess(payload)),
          catchError(() => of(new CheckNetworkStatusFailure()))
        )
      )
    )
  );
}
